import React, {useState, useEffect, useRef} from "react";

import {Help, TextInput} from "../../components/controls";

import "./Dropdown.scss";

function Dropdown({options, value, onChange, label, field, help, validate, mandatory, allowCustom, customPlaceholder}) {
  // const
  const OTHER = "___other___";
  // state
  const [selected, setSelected] = useState("");
  const [custom, setCustom] = useState("");
  // ref
  const refCustomInput = useRef();

  // mount
  useEffect(() => {
    let s = value || "";
    if(options.find(o => o.value === s)) {
      setSelected(s);
    }
    else {
      setSelected(OTHER);
      setCustom(s);
    }
    
  }, [])

  // if selected change to other, we focus the textfield
  useEffect(() => {
    if(selected === OTHER) {
      if(refCustomInput.current) {
        refCustomInput.current.focus();
      }
    }
  }, [selected]);

  // select change handler
  const onChangeSelect = (e) => {
    let v = e.target.value;
    setSelected(v);
    if(v !== OTHER) {
      onChange({field, validation:{valid:true}, value:v});  
    } 
    else {
      onChange({field, validation:{valid:true}, value:custom});
    }
  }

  // custom text changed
  const onChangeCustom = (e) => {
    let v = e.target.value;
    setCustom(v);
    onChange({field, validation:{valid:true}, value:v});
  }

  // render
  let inlineHelp = null
  if(help) {
    inlineHelp = <><span> </span><Help title={label}>{help}</Help></>
  }
  const items = options.map(o => <option value={o.value} key={o.value}>{o.label}</option>);
  let customInput = null;
  if(allowCustom) {
    items.push(<option key={OTHER} value={OTHER}>anderes</option>)
    if(selected === OTHER) {
      customInput = (
        <div className="custom">
          <input ref={refCustomInput} type="text" value={custom} onChange={onChangeCustom} placeholder={customPlaceholder} />
        </div>
      )
    }
  }
  return (
    <div className="c-dropdown">
      <div className="label">
        <span className={`text ${mandatory ? "mandatory":""}`}>
          {label} 
        </span>
        {inlineHelp}
      </div>
      <select value={selected} onChange={onChangeSelect}>
        {items}
      </select>
      {customInput}
    </div>
  )
}

export default Dropdown